<template>
    <TsTypography as="h2" variant="h3" :align="isMobile && 'center'" append-class="mb-0">{{ text }}</TsTypography>
    <TsTabsCategorySelection
      dataTestid="faq_page_topic_filters"
      :tabs="tabsList"
      :active="active_tab_id"
      @tabClick="handleTabClick"
      append-class="mb-3"
    />
    <TsFaqSection dataTestid="faq_page" title="" :content="currentAccordion" />
</template>

<script setup lang="ts">
const TsTabsCategorySelection = defineAsyncComponent(
  () => import('~/components/molecules/TsTabsCategorySelection.vue')
)

const TsFaqSection = defineAsyncComponent(
    () => import('~/components/organisms/TsFaqSection.vue')
);

const { isMobile } = useDevice()

type Props = {
    data?: object[];
    text: string;
    dataTestid?: string;
};

type Tag = {
  id: string;
  label: string;
  link?: string;
  icon?: string;
};

const props = withDefaults(defineProps<Props>(), {
  data: () => ([
    {
      name: 'My Orders',
      value: 'orders',
      content: [
        {
          heading: ' How can I order from you?',
          content: 'You can order from us in a number of simple steps.<br />' +
              '<TsTypography><strong>Step 1:</strong> Place the desired products in the shopping cart and choose, per product, for collection or delivery.</TsTypography><br />' +
              '<TsTypography><strong>Step 2:</strong> Check the contents of your shopping cart. Is it right? Then go to "Checkout".</TsTypography><br />' +
              '<TsTypography><strong>Step 3:</strong> Login or create an account. Are you already logged in? Top! Then we will skip this step for you. Saves job time again!</TsTypography><br />' +
              '<TsTypography><strong>Step 4:</strong> Do you want to say something? No problem! Then leave this in the comments.</TsTypography><br />' +
              '<TsTypography><strong>Step 5:</strong> Check your order. Are your details correct and, if you want to collect the order, have you selected the correct location for collection? Is everything correct? Then choose the desired payment method and pay.</TsTypography>'
        },
        {
          heading: 'Can I reserve products at a branch?',
          content: 'Which can! Once you have found what you were looking for, you can place and pay for your order online via Click & Collect. Your order will be ready for you 10 minutes later at the branch of your choice.\n' +
              '\n' +
              'Please note: If a product is not in stock at your location, it will take 1-2 days before you can pick up the product at the location.'
        }, {
          heading: 'If I order today, when will I receive my products?',
          content: 'If your order is in stock and you order before 10 p.m., you will receive your order the next working day. As soon as we have packed your order and presented it to PostNL, you will receive a confirmation email from us, which in most cases will contain the Track & Trace code.\n' +
              '\n' + '<br/>' +
              '<TsTypography as="span" class="text-info" >Please note: if you order during the weekend or on (inter)national holidays, your package may take a little longer.</TsTypography>'
        },
        {
          heading: 'Can I also have an order prepared at the branch?',
          content: 'That is possible. Place the desired product in your shopping cart by choosing \'PICK UP\'. Then choose the location where you want to pick it up and see if the product is in stock at the location. As soon as you have paid online, we will have the product ready for you at the branch. Without the online order, we cannot set aside or reserve products for you.'
        },
        {
          heading: 'What is the advantage of having a customer account when ordering?',
          content: 'You can view the status of your order at any time of the day via your Toolstation account. You can also view what you have previously purchased so that you can easily order it again.'
        },
        {
          heading: 'What is the advantage of having a customer account when ordering?',
          content: 'You can view the status of your order at any time of the day via your Toolstation account. You can also view what you have previously purchased so that you can easily order it again.'
        },
      ]
    },
    { name: 'Delivery', value: 'delivery'},
    { name: 'Returns', value: 'returns' },
    { name: 'PRO Card', value: 'pro_card' },
    { name: 'Payments', value: 'payments' },
    { name: 'My Account', value: 'account' },
    { name: 'Stores & Service', value: 'store_services' }
  ]),
  text: 'FAQ By Topics',
});


const currentAccordion = computed(() => props.data.find(({name}) => name === selectedTag.value)?.content)

const tabsList = computed(() => props.data.map((value, index) => { return {
  id: (index + 1).toString(),
  label: value.name
} }));
const selectedTag = ref(tabsList.value?.[0].label);

const active_tab_id = ref(tabsList.value?.[0]?.id);

function handleTabClick(tag: Tag) {
  selectedTag.value = tag.label; 
  active_tab_id.value = tag.id;
}
</script>